module.exports = __webpack_public_path__ + "prologueplus.png?7b337242b3f2df5ad8dacbfd9edb2e04";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prologueplus.png
// module id = 54
// module chunks = 0